module.exports = __webpack_public_path__ + "static/media/logo.d066bc82.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/udian-tob-lib/dist/assets/panzhou/logo.png
// module id = 727
// module chunks = 0